module.exports = __webpack_public_path__ + "static/img/banner2.e7d5f78a.png";